import { mainApi } from '../../../../api/mainApi';

import { middlewareApi } from '../../../middleware/middlewareApi';

import { AccessState } from '../../../../types';
import { IResponse } from '../../../shared/interfaces/response.interface';
import { PosgraduatePlanningCohort } from '../interfaces/posgraduatePlanningCohorts.interface';

export const posgraduatePlanningCohortsTags = middlewareApi.enhanceEndpoints({
  addTagTypes: ['PostgraduatePlanningCohorts'],
});
// Define a service using a base URL and expected endpoints
export const posgraduatePlanningCohortsApi = posgraduatePlanningCohortsTags.injectEndpoints({
  // overrideExisting: false,

  endpoints: (builder) => ({
    getPosgraduatePlanningCohorts: builder.query<
      IResponse<PosgraduatePlanningCohort>,
      {
        profileId?: number;
        page: number;
        perPage: number;
        search: string;
        sort?: string;
        type_sort?: string;
      }
    >({
      queryFn: async (
        { profileId, page, perPage, search, sort, type_sort },
        { dispatch, getState }
      ) => {
        try {
          const {
            access: { currentProfile },
          } = getState() as { access: AccessState };

          const user_profile_id = profileId || currentProfile?.profileId;

          const { data } = await mainApi.get<IResponse<PosgraduatePlanningCohort>>(
            `/cohort-annual-plannings`,
            {
              params: {
                user_profile_id,
                page,
                size: perPage,
                search,
                ...(sort && { sort }),
                ...(type_sort && { type_sort }),
              },
            }
          );
          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      providesTags: [
        {
          type: 'PostgraduatePlanningCohorts',
          id: 'TABLE',
        },
      ],
    }),

    getPosgraduatePlanningCohort: builder.query<
      PosgraduatePlanningCohort,
      {
        id: string;
        profileId: number;
      }
    >({
      queryFn: async ({ id, profileId }, { dispatch, getState }) => {
        try {
          const {
            access: { currentProfile },
          } = getState() as { access: AccessState };

          const user_profile_id = profileId || currentProfile?.profileId;

          const { data } = await mainApi.get<PosgraduatePlanningCohort>(
            `/cohort-annual-plannings/${id}`,
            {
              params: {
                user_profile_id,
              },
            }
          );
          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      providesTags: [
        {
          type: 'PostgraduatePlanningCohorts',
          id: 'TABLE',
        },
      ],
    }),

    addPosgraduatePlanningCohort: builder.mutation<
      any,
      {
        profileId: number;
        year: number;
        cohortNumber: number;
        cantParallelCohort: number;
      }
    >({
      queryFn: async (
        { profileId, year, cantParallelCohort, cohortNumber },
        { dispatch, getState }
      ) => {
        try {
          const {
            access: { currentProfile },
          } = getState() as { access: AccessState };

          const user_profile_id = profileId || currentProfile?.profileId;

          const { data } = await mainApi.post<any>(`/cohort-annual-plannings-v2`, {
            user_profile_id,
            cohorte_anual: [
              {
                year,
                cohort_number: cohortNumber,
                cant_parallel_cohort: cantParallelCohort,
              },
            ],
          });
          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      invalidatesTags: (result, error) => {
        if (!error) {
          return [
            {
              type: 'PostgraduatePlanningCohorts',
              id: 'TABLE',
            },
          ];
        }
        return [];
      },
    }),
    updatePosgraduatePlanningCohort: builder.mutation<
      any,
      {
        profileId: number;
        id: string;
        year: number;
        cohortNumber: number;
        cantParallelCohort: number;
      }
    >({
      queryFn: async (
        { id, profileId, year, cantParallelCohort, cohortNumber },
        { dispatch, getState }
      ) => {
        try {
          const {
            access: { currentProfile },
          } = getState() as { access: AccessState };

          const user_profile_id = currentProfile?.profileId;

          const { data } = await mainApi.put<any>(`/cohort-annual-plannings-v2/${id}`, {
            user_profile_id,
            year,
            cohort_number: cohortNumber,
            cant_parallel_cohort: cantParallelCohort,
          });
          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      invalidatesTags: (result, error) => {
        if (!error) {
          return [
            {
              type: 'PostgraduatePlanningCohorts',
              id: 'TABLE',
            },
          ];
        }
        return [];
      },
    }),

    deletePosgraduatePlanningCohort: builder.mutation<
      any,
      {
        profileId: number;
        id: string;
      }
    >({
      queryFn: async ({ id }, { dispatch, getState }) => {
        try {
          const {
            access: { currentProfile },
          } = getState() as { access: AccessState };

          const user_profile_id = currentProfile?.profileId;

          const { data } = await mainApi.delete<any>(`/cohort-annual-plannings/${id}`, {
            params: {
              user_profile_id,
            },
          });
          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      invalidatesTags: (result, error) => {
        if (!error) {
          return [
            {
              type: 'PostgraduatePlanningCohorts',
              id: 'TABLE',
            },
          ];
        }
        return [];
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetPosgraduatePlanningCohortsQuery,
  useLazyGetPosgraduatePlanningCohortQuery,
  useAddPosgraduatePlanningCohortMutation,
  useUpdatePosgraduatePlanningCohortMutation,
  useDeletePosgraduatePlanningCohortMutation,
} = posgraduatePlanningCohortsApi;
